import React from 'react';
import '../../App.css';
import './Products.css'

export default function Products() {
  return (
    <h1 className='products'>WHO WE ARE</h1>
  );
}